import { render, staticRenderFns } from "./RemovedServices.vue?vue&type=template&id=0cd2f72e"
import script from "./RemovedServices.vue?vue&type=script&lang=js"
export * from "./RemovedServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports